module.exports = __webpack_public_path__ + "static/media/IP56.73cfde34.PNG";